import StringUtils from './StringUtils.js';
import SvgUtils from './SvgUtils.js';

export default {
    StringUtils,SvgUtils
};



// WEBPACK FOOTER //
// ./src/utils/index.js